// Function to store data in local storage
export function setLocalStorageItem(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.error("Error storing data in local storage:", error);
    return false;
  }
}

// Function to retrieve data from local storage
export function getLocalStorageItem(key) {
  try {
    const storedValue = localStorage.getItem(key);
    return storedValue ? JSON.parse(storedValue) : null;
  } catch (error) {
    console.error("Error retrieving data from local storage:", error);
    return null;
  }
}

export function removeLocalStorageItem(key) {
  return localStorage.removeItem(key);
}

export function clearLocalStorage() {
  return localStorage.clear();
}
